import styled from 'styled-components';
import FCLabel from '@mui/material/FormControlLabel';

export const FormControlLabel = styled(FCLabel)`
  && {
    &.MuiFormControlLabel-root {
      align-items: center;
    }
  }
`;
